import { postLoginInstance, preLoginInstance } from "../../utils";
import { API_LIMIT, MAX_LIMIT, SOCIALMEDIA, START_PAGE } from "../../utils/Constant";
import { getAllContent } from "./ContentAction";
import { toast } from "react-toastify";
import { filterVerifiedItems } from "../../utils/ReusableFunctions";

// export const getCustomerNameApi = (ctx = null) => {

//   return function (dispatch, getState) {
//   return postLoginInstance.get(`admin/customer?pageSize=${ctx?.state.pageSize || API_LIMIT}&pageNumber=${ctx?.state.currentPage || START_PAGE}`)
//     .then((res) => {
//       // return ctx.setState({ dummyData: res.data.data ,});
//       dispatch(getAllCustomerData(res.data.data, ctx?.state.currentPage || START_PAGE));

//     });
//   }

// };

export const getAllContentApi = (ctx = null) => {
  // const params = new URLSearchParams(ctx.props.location.search);
  // const verify = params.get("isVerified") || "";
  ctx?.setState?.({ isLoading: true })
  const params = new URLSearchParams(ctx?.props?.location?.search);

  const allParams = Object.fromEntries(params.entries());

  const {
    isVerified,
    pageSize,
    page,
    search,
    ...rest
  } = allParams;

  // Build final filter
  const filter = {
    ...(isVerified && { isVerified }),
    ...(pageSize && { pageSize }),
    ...(page && { pageNumber: page }),
    ...(search && { searchValue: search }),
    ...rest
  };


  return function (dispatch, getState) {
    // return postLoginInstance.get(`admin/content?${verify ?'isVerified=' + verify + '&' : ''} pageSize=${ctx?.state.pageSize || API_LIMIT}&pageNumber=${ctx?.state.currentPage || START_PAGE}${ctx.state.search && `&searchValue=${ctx.state.search}`}`)
    return postLoginInstance.get(`admin/content`, {
      params: filter
    })
      .then((res) => {
        dispatch(getAllContent(res.data.data, ctx?.state.currentPage || START_PAGE));
        ctx?.setState?.({ isLoading: false })
      }).catch((error) => {
        toast.error(error?.response?.data?.message || "Something went wrong")
      }).finally(() => {
        ctx?.setState?.({ isLoading: false })
      })
  };
};

export const getAllContentFilterApi = async (ctx = null,) => {
  try {
    const data = await postLoginInstance.get(`admin/content/filter`)
    ctx?.setState?.({ filterData: data?.data?.data || [] });
    return data.data;
  } catch (error) {
    toast.error(error?.response?.data?.message || "Something went wrong")
  }
}


export const getAllOccassionDataApi = (ctx) => {

  return postLoginInstance.get(`occassion?pageSize=${MAX_LIMIT}&pageNumber=1`)
    .then((res) => {
      const list = res.data.data.list;
      const occassionOptions = filterVerifiedItems(list).map((item) => ({
        label: item.occasionName,
        value: item.uuid,
      }))
      ctx.setState({ occassionOptions })
    });

};

export const getAllDisplayPositionApi = (ctx) => {
  return postLoginInstance.get(`position`)
    .then((res) => {
      const option = filterVerifiedItems(res.data.data.list).map((item) => ({
          label: item.position,
          value: item.uuid,
          code: item.code,
        }));
      // console.log(option?.splice(2))
      ctx.setState({
        displayPositionOptions: option
      })
    })
}

export const getAllContentCreatorApi = (ctx) => {
  const newUrl = ctx?.state?.isUserPage ? 'contentCreator' : `contentCreator?type=${ctx?.state?.isEvent ? 'event' : 'content'}`
  return postLoginInstance.get(newUrl)
    .then((res) => {
      const option = filterVerifiedItems(res.data.data.list).map((item) => ({
          label: item.contentCreatorName,
          value: item.uuid,
          // code: item.code
        }));
      // console.log('this is option of creatorr', res.data.data.list)
      // let makerCreator=option?.find((item)=>item.code)
      ctx.setState({
        creatorList: option
      })
    })
}

export const getAllBrandingTypeApi = (ctx) => {
  return postLoginInstance.get(`branding`)
    .then((res) => {
      const option = filterVerifiedItems(res.data.data.list).map((item) => ({
          label: item.brandingName,
          value: item.uuid
        }));
      ctx.setState({
        brandingTypeOption: option
      })
    })
}
export const getAllSocialMediaApi = (ctx) => {
  return postLoginInstance.get(`socialMedia`)
    .then((res) => {
      const option = filterVerifiedItems(res.data.data.list).map((item) => ({
          label: item.socialMediaName,
          value: item.uuid
        }));
      ctx.setState({
        socialMediaOption: option
      })
    })
}

export const getAllUploadSectionApi = (ctx) => {
  return postLoginInstance.get(`uploadSection`)
    .then((res) => {
      const option = filterVerifiedItems(res.data.data.list).map((item) => ({
          code: item.code,
          label: item.uploadSection,
          value: item.uuid
        }));
      ctx.setState({
        uploadSectionOptions: option
      })
    })
}


export const getCommonApi = async (url) => {
  try {
    const response = await postLoginInstance.get(url);
    return response;
  } catch (error) {
    toast.error(error?.response?.data?.message || 'Something went wrong.');
  }
}
export const getSearchApi = async (url, params) => {
  try {
    const response = await preLoginInstance.get(url, { ...params });
    return response;
  } catch (error) {
    toast.error(error?.response?.data?.message || 'Something went wrong.');
  }
}
export const postAuthCommonApi = async (url, data) => {
  try {
    const response = await postLoginInstance.post(url, data);
    if (response.status < 250 && response.status > 199) {
      toast.success("Successfully Save.")
    }
    return response;
  } catch (error) {
    toast.error(error?.response?.data?.message || 'Something went wrong.');
    return false;
  }
}
export const detailsAuthCommonApi = async (url, data) => {
  try {
    const response = await postLoginInstance.post(url, data);
    if (response.status < 250 && response.status > 199) {
      // toast.success("Successfully Save.");
    }
    return response;
  } catch (error) {
    toast.error(error?.response?.data?.message || 'Something went wrong.');
    return false;
  }
}

export const putAuthCommonApi = async (url, data) => {
  try {
    const response = await postLoginInstance.put(url, data);
    if (response.status < 250 && response.status > 199) {
      toast.success("Successfully Updated.")
    }
    return response;
  } catch (error) {
    toast.error(error?.response?.data?.message || 'Something went wrong.');
    return false;
  }
}
export const patchAuthCommonApi = async (url, data, ctx) => {
  try {
    const res = await postLoginInstance.patch(url, data);
    if (res.status < 250 && res.status > 199) {
      ctx.setState({ show: false });
      toast.success("Successfully Updated.");
      ctx.props.history('/content');
    }
    return res;
  } catch (error) {
    toast.error(error?.response?.data?.message || 'Something went wrong.');
  }
}
export const deleteAuthCommonApi = async (url) => {
  try {
    const response = await postLoginInstance.delete(url);
    if (response.status < 250 && response.status > 199) {
      toast.success("Successfully Deleted.")
    }
    return response;
  } catch (error) {
    toast.error(error?.response?.data?.message || 'Something went wrong.');
  }
}

export const getDetaisContentApi = (path, ctx, isEdit = false, state) => {
  console.log(ctx)

  return postLoginInstance.get(`${path}/${ctx.props?.location?.state?.id}`)
    .then((res) => {

      const isExest = res?.data?.data?.uploadSection && res?.data?.data?.uploadSection.some(item => item.code === SOCIALMEDIA);
      ctx.setState({ isSocialMedia: isExest || false })

      return isEdit ? (ctx.setContentData(res?.data?.data)) : ctx.setState({ data: res?.data?.data });
    })
    .catch((err) => {
      console.log('Eroorr', err)
      toast.error(err?.response?.data?.message || 'Something went wrong.');
    })
}
export const gerEventregisterUser = (ctx) => {
  // console.log(ctx)
  return postLoginInstance.get(`/eventRegistration/registrationByEvent/${ctx.props.location.state.id}`)
    .then((res) => {
      return ctx.setState({ registerUser: res.data.data });
    })
    .catch((err) => {
      toast.error(err?.response?.data?.message || 'Something went wrong.');
    })
}


export const patchAuthVerifyApi = async (url, data) => {
  try {
    const res = await postLoginInstance.patch(url, data);
    if (res.status < 250 && res.status > 199) {
      toast.success("Successfully Updated.");
      return res;
    }
  } catch (error) {
    toast.error(error?.response?.data?.message || 'Something went wrong.');
    return false;
  }
}


export const getDetailsApi = (path, ctx, isEdit = false) => {
  console.log(ctx)


  return postLoginInstance.get(`${path}/${ctx.props?.location?.state?.id}`)
    .then((res) => {
      const r = res.data.data;



      return isEdit ? ctx.setContentData(res?.data.data) : ctx.setState({
        editData: r, playlistUuid: r.uuid, title: r.title, uploadFrequency: r.uploadFrequency, isAmcShow: r?.contentCreator?.contentCreatorName === "Mutual Fund Company" || false, uploadImage: r.thumbnailPath, amc: r?.amc?.uuid, platformUuid: r?.platforms?.map((item) => item?.platform?.uuid), creator: r?.contentCreator?.uuid, selectedContent: r?.contents, selectedItems: r?.contentTypes?.filter(p => p.type === "postTypes") || [],
        isPaid: `${r?.isPaid}`,
        objective: r?.objective ? r?.objective?.uuid : "",
        concept: r?.concept ? r?.concept?.map(p => p.uuid) : [],
        contentTypes: r?.contentTypes?.filter(p => p.type === "contentTypes")?.map(c => c.uuid) || [],

        description: r?.description || "",

        ageGroup: r?.ageGroup ? r?.ageGroup.split(',') : "",
        financialUnderstanding: r?.financialUnderstanding ? r?.financialUnderstanding.split(',') : "",
        gender: r?.gender ? r?.gender.split(',') : "",
        employmentType: r?.employmentType ? r?.employmentType.split(',') : '',
        incomeGroup: r?.incomeGroup ? r?.incomeGroup.split(',') : '',
        maritalStatus: r?.maritalStatus ? r?.maritalStatus.split(',') : '',
        goal: r?.goal ? r?.goal.split(',') : '',
        riskAppetite: r?.riskAppetide ? r?.riskAppetide.split(',') : '',
        partners: r?.partners?.list ? r.partners : (ctx?.partners || {}),
      }
      );

    })
    .catch((err) => {
      console.log('Eroorr', err)
      toast.error(err?.response?.data?.message || 'Something went wrong');
    })
}